var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-switch"},[_c('img',{staticClass:"toggle-img",attrs:{"data-on":!_vm.isOn,"src":"/img/icons/toggle-off-5.png"}}),_c('img',{staticClass:"toggle-img",attrs:{"data-on":_vm.isOn,"src":"/img/icons/toggle-on-5.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }